module.exports = __webpack_public_path__ + "static/img/son1.94b1d01b.jpg";